import Image from '@ingka/image';
import ProductIdentifier from '@ingka/product-identifier';
import Skeleton from '@ingka/skeleton';
import SSRIcon from '@ingka/ssr-icon';
import minusSmallIcon from '@ingka/ssr-icon/paths/minus-small';
import type { AssetArticle } from '@repo/types/asset';
import { Paragraph } from '@repo/ui/typography';

import { ArticleTitleDescription } from '@/components/article-title-description/article-title-description.component';

import { getArticleNo } from '@/utils/article.utils';
import { formatPrice } from '@/utils/translation.utils';

import sharedStyles from '@/components/article-table/styles.module.scss';
import styles from './styles.module.scss';

interface Props {
    item: AssetArticle;
    isChildItem?: boolean;
}

export const ArticleCardItem = ({ item, isChildItem }: Props) => {
    const unitPrice = formatPrice(item.unitPrice, item.currency);
    const totalPrice = formatPrice(item.totalPrice, item.currency);
    const rowStyles = isChildItem ? styles.row_child : styles.row_parent;

    const itemImage = item.imageUrl;
    const itemName = item.name;
    const itemDescription = item.description;
    const itemId = item.itemId;
    const itemQuantity = item.quantity;
    const isReferenceItem = item.isReferenceItem;
    const shouldShowImage = Boolean(itemImage) || Boolean(isChildItem);

    return (
        <div
            className={`${rowStyles} ${sharedStyles.article_table_row}`}
            data-testid={isChildItem ? 'article-card-child' : 'article-card-parent'}
        >
            <div>
                <Paragraph>{itemQuantity}</Paragraph>
            </div>
            <div>
                {isChildItem && <SSRIcon paths={minusSmallIcon} data-testid="minus-icon" />}
                {shouldShowImage && (
                    <Image src={itemImage ?? ''} fallback={!itemImage} alt="" data-testid="article-img" />
                )}
                <ArticleTitleDescription
                    title={itemName}
                    description={itemDescription}
                    isReferenceItem={isReferenceItem}
                />
            </div>
            <div>
                {itemId ? (
                    item.type !== 'TEXTLINE' && <ProductIdentifier value={getArticleNo(itemId)} subtle />
                ) : (
                    <Skeleton />
                )}
            </div>
            <div>
                <Paragraph>{unitPrice}</Paragraph>
            </div>
            <div>
                <Paragraph>{totalPrice}</Paragraph>
            </div>
        </div>
    );
};
